/**
 * Shared options for choice fields (gender, marital status).
 * Used by DataPanel, InteractiveForm, and AdminCaseDetail for dropdowns.
 */

export const GENDER_OPTIONS = [
  { value: 'M', label: 'Male' },
  { value: 'F', label: 'Female' },
  { value: 'X', label: 'Other / Non-binary' },
];

export const MARITAL_STATUS_OPTIONS = [
  { value: 'single', label: 'Single' },
  { value: 'married', label: 'Married' },
  { value: 'divorced', label: 'Divorced' },
  { value: 'widowed', label: 'Widowed' },
  { value: 'separated', label: 'Separated' },
];

export const GENDER_FIELDS = ['sexo'];
export const MARITAL_STATUS_FIELDS = ['estado_civil', 'estado_civil_representado'];

export function isGenderField(fieldName) {
  return GENDER_FIELDS.includes(fieldName);
}

export function isMaritalStatusField(fieldName) {
  return MARITAL_STATUS_FIELDS.includes(fieldName);
}
